import React from 'react';
import { SEARCH_ICON } from '../utilities/generatedClasses';
import Icon from './Icon';
import { classNameTriskeleParser } from '../utilities/customStyles';

const SearchCard = (props) => {
  const { setAction, placeholder, classNames } = props;


  return (
    <div className={`card_search ${classNames} ${classNameTriskeleParser('Search Bar', 'Boxed', 'Rectangle')}`} style={{ position: 'sticky', top: '16px' }}>
      <div style={{ marginLeft: '10px' }}>
        <Icon classNames={`size-30 ${SEARCH_ICON}`} />

      </div>
      <input
        className="input_search"
        onChange={(e) => {
          e.persist(); setAction(e);
        }}
        placeholder={placeholder} />
    </div>
  );
};

export default SearchCard;
